import * as service from './service'
export default {
  namespace: 'recruitVehicleWaiting',
  state: {
    detailData: []
  },
  effects: {
    * getDetail ({ payload }, { call, put }) {
      const res = yield call(service.getDetail, payload)
      yield put({
        type: 'save',
        payload: {
          detailData: res.data.data
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
